export default "__VITE_ASSET__BZteY3hR__"